import script from "./AdminDashboardNomineeDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardNomineeDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardNomineeDetailsModal.vue?vue&type=style&index=0&id=9a437862&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a437862"]])

export default __exports__